import { render } from "./ChronologyForm.vue?vue&type=template&id=6163e811&scoped=true"
import script from "./ChronologyForm.vue?vue&type=script&lang=js"
export * from "./ChronologyForm.vue?vue&type=script&lang=js"

import "./ChronologyForm.vue?vue&type=style&index=0&id=6163e811&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6163e811"]])

export default __exports__